// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import './Icon.module.scss';

/** @typedef {{
  name: string
} & React.HTMLAttributes<SVGElement>} SvgIconPropsType */

/** @type { StatelessComponent<SvgIconPropsType> } */
const SvgIcon = ({ name, ...rest }) => (
  <svg className={`icomoon icomoon-${name}`} {...rest}>
    <use xlinkHref={`#icomoon-${name}`} />
  </svg>
);

SvgIcon.displayName = 'SvgIcon';

SvgIcon.propTypes = {
  name: PropTypes.string.isRequired,
};

/** @typedef {{
  tip?: string,
  cssTip?: string
} & SvgIconPropsType} IconPropsType */

/** @type { StatelessComponent<IconPropsType> } */
const Icon = ({ tip, cssTip, ...rest }) => {
  if (tip) {
    return (
      <span className="Icon__TipContainer">
        <SvgIcon data-tip data-for={tip} {...rest} />
        <ReactTooltip id={tip} place="top" type="info" effect="solid">
          <span>{tip}</span>
        </ReactTooltip>
      </span>
    );
  }

  if (cssTip) {
    return (
      <span data-tip={cssTip} className="dataTooltip">
        <SvgIcon {...rest} />
      </span>
    );
  }

  return <SvgIcon {...rest} />;
};

Icon.displayName = 'Icon';

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  tip: PropTypes.string,
};

export default Icon;
